import type { ElementRef, PropsWithChildren } from 'react'
import { forwardRef, useRef } from 'react'

import type { ClassNameProp, Nullable } from '../../../types'
import { HeaderContextProvider } from './context'
import css from './Header.css'
import { HeaderCenterBlock, HeaderLeftBlock, HeaderRightBlock } from './HeaderBlocks'
import { HeaderButton } from './HeaderButton'
import { HeaderExpandablePopover } from './HeaderExpandablePopover'
import { HeaderMenu } from './HeaderMenu'
import { HeaderTinyPopover } from './HeaderTinyPopover'

const HeaderBase = forwardRef<HTMLElement, PropsWithChildren<ClassNameProp>>(function Header(
  { className = '', children },
  ref,
) {
  const headerRef = useRef<Nullable<ElementRef<'header'>>>(null)

  // FIXME Нужно разделить реф на хедер, но ни констовский хук
  // ни самописный почему-то не работают
  // Это работает
  if (ref && 'current' in ref) {
    ref.current = headerRef.current
  } else {
    ref?.(headerRef.current)
  }

  return (
    <header ref={headerRef} className={`${className} ${css.header}`}>
      <HeaderContextProvider header={headerRef}>{children}</HeaderContextProvider>
    </header>
  )
})

/**
 * Шапка процесса
 *
 * Умеет позиционировать объекты компоненты слева, справа и по центру:
 * - Right
 * - Left
 * - Center
 *
 * Содержит в себе дополнительные компоненты:
 * - Button
 * - Popover
 * - Menu
 */
export const Header = Object.assign(HeaderBase, {
  LeftBlock: HeaderLeftBlock,
  RightBlock: HeaderRightBlock,
  Center: HeaderCenterBlock,
  Button: HeaderButton,
  ExpandablePopover: HeaderExpandablePopover,
  Menu: HeaderMenu,
  TinyPopover: HeaderTinyPopover,
})
